import React, { type CSSProperties } from "react";

import clsx from "clsx";

import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { Checkbox } from "@shared/checkbox";

interface Props {
  style?: CSSProperties;
  className?: string;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

export const Option = ({ style, className, label, value, onChange }: Props) => {
  const { designElementManager } = useDesignElementManager();

  const icon = designElementManager.getDesignElement(label).getComponent({
    size: "20px",
  });

  return (
    <div
      className={clsx(
        "px-4 hover:bg-cosmic-4 h-9 w-full flex items-center gap-2 cursor-pointer",
        "text-xs",
        className,
      )}
      style={style}
      onClick={() => onChange(!value)}
    >
      <Checkbox value={value} />
      {icon}
      {label}
    </div>
  );
};
